export const UrlSystemToMedicalSystem = {
    'http://hl7.org/fhir/sid/icd-10': 'ICD10',
    'http://hl7.org/fhir/sid/icd-10-cm': 'ICD10CM',
    'http://hl7.org/fhir/sid/ex-icd-10-procedures': 'ICD10PCS',
    'http://snomed.info/sct': 'SNOMED',
    'http://loinc.org': 'LOINC',
    'http://www.nlm.nih.gov/research/umls/rxnorm': 'RxNorm',
    'http://hl7.org/fhir/sid/ndc': 'NDC',
    'http://www.ama-assn.org/go/cpt': 'CPT4',
    'http://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets': 'HCPCS',
    'http://hl7.org/fhir/sid/cvx': 'CVX',
};
export const MedicalSystemToUrlSystem = Object.entries(UrlSystemToMedicalSystem).reduce((acc, [url, code]) => {
    acc[code] = url;
    return acc;
}, {});
